import { Col, DatePicker, Row, Tabs, message, Typography, Divider } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input } from "antd";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Select } from "antd";
import { fetchAllFraksi } from "redux/features/fraksi";
import { MyEditor } from "../../../components/Editor";
import ImageUploader from "components/shared-components/ImageUploader";
import moment from "moment";
import {
  addEmployee,
  fetchOneEmployee,
  updateEmployee,
} from "redux/features/employee";
import { jabatanOptions, layout } from "./constant";
import { PhotoUploadCard } from "../detail-dewan/PhotoUploadCard";

const selectStyle = {
  width: "100%",
  backgroundColor: "white",
};

const rules = [
  {
    required: true,
    message: "Wajib Diisi!",
  },
];

export const ADD_DEWAN = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const location = useLocation();

  const [idBody, setIdBody] = useState("");
  const [enBody, setEnBody] = useState("");
  const [subcategories, setSubcategories] = useState();
  const [tags, setTags] = useState();
  const [imgUrl, setImgUrl] = useState("");
  const [imgUrlDisplay, setImgUrlDisplay] = useState("");

  const onFinish = (values) => {
    if (location?.state?.id) {
      updateData(values);
    } else {
      createData(values);
    }
  };

  const createData = async (values) => {
    console.log("create data :", values);
    try {
      await dispatch(
        addEmployee({
          ...values,
          photo: imgUrl
            ? imgUrl
            : "https://api.banyuasinkab.info/uploads/1750945134485-dummy-image.jpg",
          //   description: idBody ? idBody : "",
          //   fraksi_id: parseInt(values.fraksi_id),
          //   komisi_id: parseInt(values.komisi_id),
        })
      ).unwrap();
      history.push("/app/kepegawaian");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const updateData = async (values) => {
    try {
      await dispatch(
        updateEmployee({
          ...values,
          //   description: idBody ? idBody : "",
          //   fraksi_id: parseInt(values.fraksi_id),
          //   komisi_id: parseInt(values.komisi_id),
          //   fraksi: parseInt(values.fraksi_id),
          //   komisi: parseInt(values.komisi_id),
          photo: imgUrl ? imgUrl : undefined,
          //   user_id: 1,
          id: location?.state?.id,
        })
      ).unwrap();
      history.push("/app/kepegawaian");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getDataById = async (id) => {
    try {
      const data = await dispatch(fetchOneEmployee(id)).unwrap();
      form.setFieldsValue({
        ...data.data,
        // department_id: data.data.department?.id,
        department: data.data.department?.name,
      });
      setImgUrlDisplay(data.data.photo);
    } catch (err) {
      console.log(err);
    }
  };

  const handleImageUpload = (info) => {
    console.log("info :", info);
    if (info.file.status === "uploading") {
      // setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      setImgUrl(info.file.response.data.secure_url);
    }
  };

  useEffect(() => {
    console.log(location?.state?.id);
    if (location?.state?.id) {
      getDataById(location?.state?.id);
    }
  }, []);

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Typography.Title level={2}>
            Tambah/Update Data Pegawai
          </Typography.Title>
          <Typography.Paragraph>
            Isi data pegawai sesuai dengan data yang ada.
          </Typography.Paragraph>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={18} sm={18} md={18} lg={18} gap={3}>
          <Form
            name="basic"
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            initialValues={{ department_id: 1, functional_position: "test" }}
            {...layout}
          >
            {/* <Typography.Title level={2}>Informasi Pribadi</Typography.Title> */}
            <Col span={24}>
              <Card
                title="Informasi Pribadi"
                headStyle={{
                  borderBottom: "1px solid #f0f0f0",
                  paddingBottom: 12,
                }}
                style={{ marginBottom: 8 }}
              >
                <Form.Item label="Nama Lengkap" name="name" rules={rules}>
                  <Input placeholder="Masukkan nama lengkap" />
                </Form.Item>

                <Form.Item label="NIP" name="nip" rules={rules}>
                  <Input placeholder="Masukkan NIP, contoh: 198001012000121001" />
                </Form.Item>

                <Form.Item label="Email" name="email" rules={rules}>
                  <Input placeholder="Masukkan email, contoh: nama@email.com" />
                </Form.Item>
                <Form.Item label="No Hp (WA)" name="phone">
                  <Input
                    addonBefore="+62"
                    placeholder="Masukkan nomor tanpa 0, misal: 81234567890"
                    type="tel"
                  />
                </Form.Item>
              </Card>
            </Col>

            {/* <Divider></Divider>
            <Typography.Title level={2}>Jabatan</Typography.Title> */}
            <Col span={24}>
              <Card
                title="Jabatan"
                headStyle={{
                  borderBottom: "1px solid #f0f0f0",
                  paddingBottom: 12,
                }}
                style={{ marginBottom: 8 }}
              >
                <Form.Item label="Departemen" name="department_id">
                  <Select
                    defaultValue={1}
                    placeholder="Pilih Departemen"
                    disabled
                  >
                    <Select.Option value={1}>Sekretariat DPRD</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item label="Jabatan" name="position" rules={rules}>
                  <Select placeholder="Pilih Jabatan" showSearch>
                    {jabatanOptions.map((jabatan) => (
                      <Select.Option key={jabatan} value={jabatan}>
                        {jabatan}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Jabatan Fungsional"
                  name="functional_position"
                  hidden
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Tipe Pegawai"
                  name="description"
                  rules={rules}
                >
                  <Select placeholder="Pilih Tipe Pegawai">
                    <Select.Option value="Pimpinan">Pimpinan</Select.Option>
                    <Select.Option value="Staff">Staff</Select.Option>
                    {/* <Select.Option value="Dummy">Dummy</Select.Option> */}
                  </Select>
                </Form.Item>
              </Card>

              <Form.Item wrapperCol={24}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Form>
        </Col>
        <Col xs={6} sm={6} md={6} lg={6} gap={3}>
          <PhotoUploadCard
            imgUrlDisplay={imgUrlDisplay}
            imgUrl={imgUrl}
            onChangeImage={handleImageUpload}
          ></PhotoUploadCard>
        </Col>
      </Row>
    </>
  );
};

export default ADD_DEWAN;
